import {inject, Injectable} from '@angular/core';
import {RestClient} from '../../Api/DcoApi/Client/RestClient';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {
  VersandFehler,
  VersandFehlerResult,
  VersandMultipartResponseResult,
  VersandUI
} from '../../Api/DcoApi/Versand/VersandUI';
import {EmailDialog} from '../Pages/Versand/EmailDialog';

@Injectable({
  providedIn: 'root' // Das macht den Service zu einem anwendungsweiten Singleton
})
export class VersandService {
  private Client: RestClient = new RestClient();

  private modalService = inject(NgbModal);

  async InitTracking(key: number): Promise<VersandUI | null> {
    try {
      return await this.Client.Post(`/Backend/Api/V2/VersandAuftraege/${key}/CreateDHLRequest`, {});
    }catch (err: any){
      if(err)
        if (err.status === 400) {
          // err.error enthält den geparsten Body, den das Backend geschickt hat
          const errorBody = err.error;
          if(errorBody)
          {
            alert("Fehler beim Versand: "+ errorBody.fehlerText);
            return  null;
          }

        }
      alert("Fehler beim Versand");
      return  null
    }

  }

  async InitTrackingForOrder(key: number, Versand:boolean = true): Promise<VersandUI | null> {
    try {
      return await this.Client.Post(`/Backend/Api/V2/VersandAuftraege/${key}/CreateDHLRequestForOrder?Versand=${Versand}`, {});
    }catch (err: any){
      if(err)
        if (err.status === 400) {
          // err.error enthält den geparsten Body, den das Backend geschickt hat
          const errorBody = err.error;
          if(errorBody)
          {
            alert("Fehler beim Versand: "+ errorBody.fehlerText);
            return  null;
          }

        }
      alert("Fehler beim Versand");
      return  null
    }

  }

  openSendDialog(trackingnumber: string, mail: string, isVersand: boolean = false): Promise<void> {
    return new Promise((res,rej) => {
      var modal = this.modalService.open(EmailDialog);
      modal.update({size: 'Dialog'});
      modal.componentInstance.trackingnummer = trackingnumber;
      modal.componentInstance.Mail = mail;
      modal.componentInstance.isVersand = isVersand;
      modal.closed.subscribe(async b => {
        res();
      });
      modal.dismissed.subscribe(async b => {
        res();
      });
    });
  }

  async ResetTracking(id:number)
  {
    return await this.Client.Post(`/Backend/Api/V2/VersandAuftraege/${id}/ResetTracking`, {});
  }

  async DownloadMultiPart(url: string, ids: number[], Versand: boolean = true): Promise<void> {

   try {
     var request = await this.Client.PostMultipart<VersandFehlerResult, any>(url, {IDs: ids, Versand: Versand});

     if (request && request.jsonData && request.jsonData.FehlerListe && request.jsonData.FehlerListe.length > 0) {
       alert("Folgende Aufträge konnten nicht eingetragen werden: \n\n" + request.jsonData.FehlerListe.map(fehler => `${fehler.Auftrag}: ${fehler.FehlerText}`).join('\n'));
     }

     // Datei im Browser herunterladen
     const downloadLink = document.createElement('a');
     downloadLink.href = window.URL.createObjectURL(request.fileBlob);
     downloadLink.download = request.fileName;

     document.body.appendChild(downloadLink);
     downloadLink.click();
     document.body.removeChild(downloadLink);
   }catch (e){
     alert("Fehler beim Herunterladen der Datei: " + e);
   }
  }

  async downloadFileWithToken(trackingnummer: string, isQR: boolean = false) {
    try {
      // 1. Fetch the data with the Authorization header
      const response = await this.Client.GetFile(`/Backend/Api/V2/VersandAuftraege/${trackingnummer}/File?Qr=${isQR}`);

      const blob = response.body;
      if (!blob) {
        throw new Error('Response body is empty.');
      }

      // 2. Extract the filename from the Content-Disposition header if available
      let fileName = isQR ? `${trackingnummer}_QR.png` : `${trackingnummer}.pdf`;
      const disposition = response.headers.get('content-disposition');
      if (disposition && disposition.includes('filename=')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }

      // 4. Create a local URL pointing to that blob
      const blobUrl = window.URL.createObjectURL(blob);

      // 5. Create an invisible <a> tag dynamically
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = fileName;

      // 6. Append to DOM, trigger click, and clean up immediately
      document.body.appendChild(anchor);
      anchor.click();

      // Cleanup
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.log('File download failed:', error);

    }
  }
}
